import Navigation from './index'

export function goToAdminThunk() {
  return (_, getState) => {
    const { csrf } = getState().auth
    Navigation.navigateToAdmin(csrf)
  }
}
